import {Grid, Card, CardContent, Button} from '@mui/material'

import { Plus } from 'react-feather'
import { useFechInitVehicleApplies } from './hooks';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { VehiclesAppliesTable } from './VehiclesTable/VehiclesTable';
import { VehicleForm } from './VehicleForm/VehicleForm';

const AdminVehiclesApplies = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleApplies({location, paramsURL})

  const {
    globalStates,
    Actions
} = useFetchInit

const { showForm} = globalStates

const {handleClickShowForm} = Actions

  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['49_ADMIN', '137_VEHICULOS_SOLICITUDES']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(!showForm)&&(
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <div className='h4 mt-1 mb-1'> Solicitudes de Vehiculos</div>
                    <div className="border-bottom border-dark"></div>

                    <div className="pt-4"></div>
                    <VehiclesAppliesTable 
                        useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <VehicleForm 
                      useFetchInit={useFetchInit}
                  />
              </div>
          </>
        )}
      </div>
    </AllowedAccess>

  )
}

export {
  AdminVehiclesApplies
}
